import React from 'react'
import { connect } from 'react-redux'
import {Link} from 'react-router-dom'
import Icon from '@material-ui/core/Icon';

import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import Drawer from '@material-ui/core/Drawer';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import CollapseButton from './Mui/CollapseButton';
import Hidden from '@material-ui/core/Hidden';

import {
  set_path
} from '../actions'

const styles = {
  listItems: {
    paddingTop: '20px',
    paddingBottom: '20px',
    //paddingLeft: '24px',
    borderBottom: '1px solid #E8E9EA'
  },
};

const mapStateToProps = state => {
  return {
    current: state.path.path,
    current_user: state.auth.current_user.data
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setPath: path => dispatch( set_path(path) )
  }
}

class ConnectedSidebar extends React.Component {
  state = {
    questionsOpen: false,
    templatesOpen: false,
    usersOpen: false,
    couponsOpen: false,
    resultsOpen: false,
    businessesOpen: false,
  }

  initState = {
    questionsOpen: false,
    templatesOpen: false,
    usersOpen: false,
    couponsOpen: false,
    resultsOpen: false,
    businessesOpen: false,
  }

  /* NEW */
  /*
    USE THIS ARRAY TO ADD ITEMS TO THE SIDEBAR
    FOLLOW THE EXISTING ITEMS AS DEMO
  */
  items = [
    {
      name: "Dashboard", current: "dashboard", link: "/",
    },
    { name: "Questions", current: "", link: "", state: "questionsOpen",
      items: [
        { name: "View Questions", current: "questions", link: "/questions" },
        { name: "Add Question", current: "newquestion", link: "/questions/new" },
      ]
    },
    { name: "Templates", current: "", link: "", state: "templatesOpen", requires: ["admin", "expert"],
      items: [
        { name: "View Templates", current: "templates", link: "/templates" },
        { name: "Add Template", current: "newtemplate", link: "/templates/new", requires: ["admin"] },
      ]
    },
    { name: "Results", current: "", link: "", state: "resultsOpen", requires: ["admin", "expert"],
      items: [
        { name: "Instance Results", current: "testresults", link: "/tests" },
        { name: "Template Results", current: "templateresults", link: "/templates/results" },
        { name: "Question Results", current: "questionresults", link: "/questions/results" },
      ]
    },
    { name: "Users", current: "", link: "", requires: ["admin"], state: "usersOpen",
      items: [
        { name: "Test Takers", current: "testtakers", link: "/test_takers" },
        { name: "Prospects", current: "prospects", link: "/prospects" },
        { name: "B2B Users", current: "b2baccounts", link: "/b2busers" },
        { name: "B2B Prospects", current: "b2bprospects", link: "/b2bprospects" },
        { name: "System Users", current: "systemusers", link: "/system_users" },
        { name: "Add User", current: "adduser", link: "/users/new" },
      ]
    },
    { name: "B2B", current: "", link: "", requires: ["admin"], state: "businessesOpen",
      items: [
        { name: "Businesses", current: "businesses", link: "/businesses" },
        { name: "Add Business", current: "addbusiness", link: "/businesses/new" },
        // { name: "B2B Users", current: "b2busers", link: "/b2busers" },
        // { name: "Add B2B User", current: "addb2buser", link: "/b2busers/new" },
        { name: "Vouchers", current: "vouchers", link: "/vouchers" },
        { name: "Add Voucher", current: "addvoucher", link: "/vouchers/new" },
      ]
    },
    { name: "Coupons", current: "", link: "", requires: ["admin"], state: "couponsOpen",
      items: [
        { name: "View Coupons", current: "coupons", link: "/coupons" },
        { name: "Add Coupon", current: "addcoupon", link: "/coupons/new" },
      ]
    },
    { name: "Purchases", current: "payments", link: "/purchases", requires: ["admin"] },
    { name: "Settings", current: "settings", link: "/settings", requires: ["admin"] },
    { name: "Feedback", current: "feedback", link: "/feedback", requires: ["admin"] },
]

  getState(value) {
    return this.state[value]
  }

  toggleCollapse(item, value=null) {
    if (value === null) {
      this.setState({...this.initState, [item]: !this.state[item]})
    } else {
      this.setState({...this.initState, [item]: value })
    }
  }

  componentDidMount() {
    this.checkCurrent()
  }

  componentDidUpdate(prevProps, prevState) {
    if ( this.props.current !== prevProps.current && this.props.current !== null && this.props.current !== undefined ) {
      // const { current = this.props }
      // let master = ''
      // this.items.forEach( item => {
      //   if (master !== '') {
      //     return
      //   }
      //   if (item.items) {
      //     item.items.forEach( ii => {
      //       if ( ii === current ) {
      //         master = item.state
      //       }
      //     })
      //   }
      // })
      // if (master !== '') {
      //   this.toggleCollapse(master, true)
      // }
      this.checkCurrent()
    }
  }

  checkCurrent() {
    const { current } = this.props
    let master = ''
    this.items.forEach( item => {
      if (master !== '') {
        return
      }
      if (item.items) {
        item.items.forEach( ii => {
          if ( ii.current === current ) {
            master = item.state
          }
        })
      }
    })
    if (master !== '') {
      this.toggleCollapse(master, true)
    }
  }

  render() {
    const { classes, current_user } = this.props;

    const getState = this.getState.bind(this)
    const toggleCollapse = this.toggleCollapse.bind(this)

    const listItem = (text, current, link) => {
      const CustomLink = props => {
        const {className, ...other} = props
        return (
          <Link {...other} className={`${props.className} c-blue no-t-decoration body2`}
          >{text}</Link>
        )
      }

      return (
        <ListItem
          button
          component={CustomLink} to={link}
          className={`items pl-24 pl-xs-16 ${classes.nested} ${this.props.current === current ? 'is_current' : ''}`}
          style={styles.listItems}
          TouchRippleProps={{
            className: 'blue_ripple'
          }}
          onClick={e=> {
              this.props.mobileMenuHandler();
              this.props.setPath(current)
            }
          }
        />
      )
    }

    const spanItem = (text, current, link) => {
      return (
        <ListItem
          button
          component={Link} to={link}
          className={`spans items ${classes.nested} ${this.props.current === current ? 'is_current' : ''}`}
          TouchRippleProps={{
            className: 'blue_ripple'
          }}
          style={styles.listItems}
          onClick={
            (e)=> {
              this.props.mobileMenuHandler()
              this.props.setPath(current)
            }
          }
        >
          <ListItemText inset primary={
            <span className='sidebar-internal-link'>{text}</span>
          } onClick={e=>{
            this.props.setPath(current)
          }}
          className="spanItem"
          />
        </ListItem>
      )
    }

    return (
      <Drawer
        anchor="left"
        variant="permanent"
        className="drawer_link"
        classes={{
          paper: classes.drawerPaper,
        }}
      >
        <div className={classes.toolbar} />
        <List className="sidebar-list" disablePadding={true}>

          { this.items.map(item => {
            const { name, link, current, requires, items, state } = item

            if ( requires !== undefined && requires.length > 0 && requires.indexOf(current_user.role) === -1 ) {
              return <React.Fragment key={item.name} />
            } else if (items !== undefined && items.length > 0) {
              return (
                <React.Fragment key={item.name}>
                  <ListItem button
                    onClick={e=> toggleCollapse(state)} style={styles.listItems} className="items"
                    TouchRippleProps={{
                      className: 'blue_ripple'
                  }}>
                    <ListItemText inset primary={name} className="spans" />
                    {getState(state) ? <ExpandLess /> : <ExpandMore />}
                  </ListItem>
                  <Collapse in={getState(state)} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                      { items.map( span => {
                        if ( span.requires !== undefined &&  span.requires.length > 0 && span.requires.indexOf(current_user.role) === -1) {
                          return <React.Fragment key={span.name} />
                        }
                        return (
                          <React.Fragment key={span.name}>
                            { spanItem(span.name, span.current, span.link) }
                          </React.Fragment>
                        )
                      })}
                    </List>
                  </Collapse>
                  <Divider className="bg-divider" />
                </React.Fragment>
              )
            } else {
              return (
                <React.Fragment key={name}>
                  { listItem( name, current, link) }
                  <Divider className="bg-divider" />
                </React.Fragment>
              )
            }

          })}
        </List>

        <Hidden smDown>
          <CollapseButton
            className="collapse"
            TouchRippleProps={{
              className: 'blue_ripple'
            }}
            title={this.props.collapseSidebar ? 'Expand' : 'Collapse'}
            onClick={e=> {
              this.props.collapseSidebarHandler();
            }
          }
          ><span className="collapse-text d-none">Collapse</span> <Icon style={{color: 'white'}}>{this.props.collapseSidebar ? 'navigate_next' : 'navigate_before'}</Icon></CollapseButton>
        </Hidden>
      </Drawer>
    );
  }
}

const Sidebar = connect(mapStateToProps, mapDispatchToProps)(ConnectedSidebar)
export default Sidebar



// WEBPACK FOOTER //
// ./src/js/components/Sidebar.js